<template>
  <div>
      <public-head title="校派"></public-head>
        <div class="contain">
  <div class="title">{{info.title}}</div>
  <div class="content">
    <p v-html="info.content" class="dialog-h5"></p>
  </div>
</div>
<!-- 评论区 -->
<div class="wrap">
  <div class="discuss" v-for="(item,index) in commentList" :key="index">
    <div class="discuss-value">
      <img class="head" :src="item.head_pic" />
      <div class="value">
        <div class="value-wrap">
          <div>
            <div class="name">{{item.nickname}}</div>
            <div class="time">{{item.addtime}}</div>
          </div>
          <!-- 点赞 -->
          <!-- <div :class="['like', item.is_zan==1?'iconfont icon-thumbed':'iconfont icon-thumb']" @click="thumb(item.id)">{{item.zan_num}}</div> -->
        </div>

        <div class="discuss-content" @click="reply(item.id,item.uid,item.nickname)" >
          <div v-if="item.touser_id!=0">
              <div>回复{{item.tonickname}}：</div></div>{{item.content}}
              </div>
      </div>
    </div>
  </div>
</div>
  <div class="footer" v-if="isshow">
    <!-- 评论，点击弹出评论框 -->
    <div class="comment" @click='focusButn'>写下你的看法吧！</div>
    <div :class="['cell' ,'font_family', collected?'icon-shoucangshixin celled':'icon-shoucang1 detailesicon']" @click="shoucang">
       <van-icon name="star"  :class="info.celled==1?'color':''"/>
    </div>
    <!-- <button open-type="share" class="share font_family icon-fenxiang1"></button> -->
  </div>
  <!-- 评论框 -->
  <!-- style='bottom:{{height == ""?0:height}}px;' hidden='{{!isInput}}' -->
  <div class='commentInputView' v-if="show">
    <div class="btn">
      <div class="cancel" @click="cancel">取消</div>
      <div class="send" @click="comment">发布</div>
    </div>
    <div class='commentInput'>
        <textarea  fixed='true' contenteditable="true" auto-height="true" class='input' maxlength='maxTextLen' v-model="val"
        :placeholder="isReply?'回复 '+replyName+':':''"></textarea>
      <!-- <input class='input' :axlength='maxTextLen' v-model="val"/> -->
    </div>
    <!-- <div class="limit">{{length}}/{{maxTextLen}}</div> -->
  </div>
  </div>
</template>

<script>
    import PublicHead from "../../components/publicHead";
  import { httpPost } from "../../axios/index";
export default {
    data() {
        return {
        article_id: 0,
        info: {}, //文章详情
        collected: false, //收藏
        commentList: [], //文章评论
        replyList: [], //评论别人
        // 键盘收起弹出
        focusInput: false,
        height: '',
        isInput: false,
        maxTextLen: 100, //最大输入长度
        length: 0, //当前输入内容长度
        value: '', //评论内容
        isReply: false, //回复
        replyName: '', //被回复昵称
        zan: false, //是否点赞
        show:false,
        isshow:true,
        val:"",
         celled: false
        };
    },
    created() {},
    methods: {
        // 回复评论
        reply(id,uid,name){
           
             this.id=id,
            this.touserid=uid,
            this.isReply=true,
            this.replyName=name
            this.focusButn();
        },
        // 点击提交评论
        comment(e){
            httpPost("/index/add_comment", {
                    aid: this.$route.query.id,
                    pid: this.id,
                    content: this.val,
                    uid: this.$store.state. userInfo.user_id,
                    touser_id: this.touserid,
            }).then(res => {
              
                if (res.code === 1) {
                     this.show=false;
                    this.isshow=true;
                    this.val="";
                  this.$toast.success(res.msg);
                }
                else{
                    this.$toast.fail(res.msg)
                }
               
            });
        },
        // 点击取消
        cancel(){
             this.show=false;
            this.isshow=true;
        },
       
        // 点击写下你的看法吧
        focusButn(){
            this.show=true;
            this.isshow=false;
        },
        // 点击收藏
        shoucang(){
             httpPost("/usercell/article_cell", {
               article_id: this.$route.query.id,
               uid:this.$store.state. userInfo.user_id
            }).then(res => {
              console.log(res);
                if (res.msg == "收藏成功") {
                    // this.celled=true;
                    this.info.celled=1
                    this.$toast.success(res.msg);
                }else{
                     this.celled=false;
                      this.info.celled=0
                     this.$toast.success(res.msg);
                }
                if(res.code===0){
                    this.$toast.fail('您还未登录');
                }
            });
        },
        // 新闻详情数据
        fetchOcupptation(name) {
            httpPost("/index/details", {
               id: this.$route.query.id,
               uid:this.$store.state. userInfo.user_id
            }).then(res => {
               console.log(res);
                if (res.code === 1) {
                   this.info=res.info
                }
            });
        },
        // 获取评论列表数据
        fetchComment(){
             httpPost("/index/comment_list", {
               id: this.$route.query.id,
               uid:this.$store.state. userInfo.user_id
            }).then(res => {
               
                if (res.code === 1) {
                  this.commentList=res.list
                }
            });
        }
    },
    mounted() {
        this.fetchOcupptation();
        this.fetchComment();  
    },
    components: {
        PublicHead
    }
}
</script>

<style scoped>
.color{
   color: #e5b626;
}
.img{
    width: 20px;
}
.pic {
  width: 100%;
  height: 30.125rem;
  border-radius: 0px 0px 0.3125rem 0.3125rem;
}

/* 文章内容 */

.contain {
  width: 19.4375rem;
  margin: 1.5625rem auto;
  padding-bottom: 1.5625rem;
  color: #2e2f41;
  border-bottom: 0.0625rem solid #dcdcdc;
  margin-top: 46px;
}

.title {
  font-size: 1.5rem;
}
.dialog-h5 >>> img,p,span {
  width: 100%;
}
.content {
  margin-top: 2.375rem;
  font-size: 1rem;
}

/* 评论信息 */

.wrap {
  width: 20.25rem;
  margin: 3.3125rem 0 4.375rem 0.9375rem;
}

.discuss {
  margin-bottom: 1.1875rem;
  padding-bottom: 1.125rem;
  border-bottom: 0.0625rem solid #eee;
  margin-top: 0.9375rem;
}

.discuss-value {
  display: flex;
}

.head {
  width: 2.375rem;
  height: 2.375rem;
  border-radius: 50%;
}

.value {
  width: 17.1875rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 0.5625rem;
}

.value-wrap {
  display: flex;
  justify-content: space-between;
}

.name,.reply-content {
  font-size:0.875rem;
  color: #0c0c0c;
}

.time {
  font-size: 0.75rem;
  color: #999;
}

.discuss-content {
  font-size: 0.875rem;
  line-height: 1.375rem;
  color: #0c0c0c;
}

/* 评论 */

.footer {
  width: 100%;
  height:3.0625rem;
  background-color: #fff;
  box-shadow: 0px -0.125rem 0.1875rem 0px rgba(0, 0, 0, 0.09);
  position: fixed;
  bottom: 0;
}

.comment::before {
  content: '';
  width: 1.375rem;
  height: 1rem;
  background: url("https://new.schoolpi.net/attach/small_program/class/comment.png");
  background-size: 100%;
  position: absolute;
  left: 1.75rem;
  top: 0.625rem;
}

.comment {
  width: 13.625rem;
  height: 2.1875rem;
  background-color: #f5f5f5;
  border-radius: 1.125rem;
  border: solid 0.0625rem #d3d3d3;
  margin: 0.375rem 1.875rem;
  text-align: center;
  line-height: 2.1875rem;
  font-size: 0.75rem;
  color: #959595;
  position: relative;
}

.cell {
  position: absolute;
  right: 4.0625rem;
  top: 0.625rem;
  font-size: 1.5625rem;
}

.celled {
   color: #e5b626; 
}

.share {
  position: absolute;
  top: 0.875rem;
  right: 2.1875rem;
  font-size: 1.25rem;
  background-color: transparent;
  line-height: normal;
}

/* 弹出的评论框 */

.commentInputView {
  width: 100%;
  height: 7.8125rem;
  background-color: #fff;
  position: fixed;
  bottom: 0px;
  border-top: 0.0625rem solid #f1f1f1;
  z-index: 100;
}

.btn {
  font-size: 0.8125rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  padding: 0.8125rem;
}

.cancel {
  color: #999;
}

.send {
  color: #0c0c0c;
}

.commentInput {
  width: 21.6875rem;
  font-size: 0.875rem;
  border-bottom: 0.0625rem solid #f1f1f1;
  margin: 0 auto;
}

.input {
  width: 21.4375rem;
  padding: 0.5rem;
  font-size: 0.875rem;
  overflow: hidden;
  margin-bottom: 1.125rem;
}

.limit {
  text-align: right;
  font-size: 0.75rem;
  color: #999;
  margin-right: 26rpx;
  margin-top: 0.5rem;
}

</style>